
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components:{
XHeader
},
data () {
return {
model:{},
initModel:[],  //分类及视频
initProject:[],
videoUrl:{} ,  //主视频地址
initTopVideo:{} ,
title:{}
}
},
created(){
this.getData(this.$route.query.projectId)
},
methods: {
goBack(){
this.$router.push({
path : '/learn/index',
query : {}
})
},
getData(projectId){
if(projectId==1){
this.title="N2"
}else if(projectId==2){
this.title="MC"
}else{
this.title="IOT"
}
this.model.projectId=projectId
this.$http.post(this.global.httpUrl + '/rest/v1/m/mlearn/getIndexData',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.initModel= res.body.data
this.videoUrl=res.body.project.projectMainVideoUrl

this.initTopVideo=res.body.top
console.log(this.initTopVideo)
}
},function(res){
});
},
openVideo(videoId){
this.$router.push('/learn/product/detail?videoId='+videoId)
}

},
}



// WEBPACK FOOTER //
// ./src/views/learn/productList.vue